module.exports = __webpack_public_path__ + "static/media/grosser_heidegrashuepfer_balz.5c6ea5a5.mp3";